export default "__VITE_ASSET__5ZU7_OgW__"